import { Features } from 'generated/featureDefinitions'
import {
  AttendanceCustomPeriodEmployeeItemFragment,
  TimeInsightsValueObjectsInconsistencyTypeEnum,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { useAttendanceFeatures } from 'modules/attendance/lib/attendanceFeaturesContext'

export const useAlerts = () => {
  const { featureAvailability: hasTimeTrackingInconsistencies } = useAttendanceFeatures(
    Features.time_tracking_time_alerts
  )
  const alertsFilter:
    | {
        alerts?:
          | {
              type: 'in'
              label: string
              options: {
                options: {
                  label: string
                  value: TimeInsightsValueObjectsInconsistencyTypeEnum
                }[]
              }
            }
          | undefined
      }
    | undefined = hasTimeTrackingInconsistencies
    ? {
        alerts: {
          type: 'in',
          label: i18n.t('time_tracking.table_collection.filters.alerts'),
          options: {
            options: [
              {
                label: i18n.t(
                  'time_tracking.table_collection.filters.alerts_options.missing_clock_in'
                ),
                value: 'missing_clock_in',
              },
              {
                label: i18n.t(
                  'time_tracking.table_collection.filters.alerts_options.missing_clock_out'
                ),
                value: 'missing_clock_out',
              },

              {
                label: i18n.t(
                  'time_tracking.table_collection.filters.alerts_options.missing_break_time'
                ),
                value: 'missing_break_time',
              },

              {
                label: i18n.t(
                  'time_tracking.table_collection.filters.alerts_options.insufficient_break_duration'
                ),
                value: 'insufficient_break_duration',
              },
            ],
          },
        },
      }
    : {}

  const alertsColumn = hasTimeTrackingInconsistencies
    ? [
        {
          label: i18n.t('time_tracking.table_collection.alerts'),
          sorting: 'alertsCount' as const,
          render: (
            item: AttendanceCustomPeriodEmployeeItemFragment
          ): { type: 'status'; value: { status: string; label: string } } => {
            const count = item.timeInsightsInconsistenciesConnection?.totalCount ?? 0

            if (count === 0) {
              return {
                type: 'status',
                value: {
                  status: 'success',
                  label: '-',
                },
              }
            }
            return {
              type: 'status',
              value: {
                status: 'critical',
                label: `${count}`,
              },
            }
          },
        },
      ]
    : []

  return {
    alertsFilter,
    hasTimeTrackingInconsistencies,
    alertsColumn,
  }
}
